import { render, staticRenderFns } from "./invoice-company-detail.vue?vue&type=template&id=898466c2&scoped=true&"
import script from "./invoice-company-detail.vue?vue&type=script&lang=js&"
export * from "./invoice-company-detail.vue?vue&type=script&lang=js&"
import style0 from "./invoice-company-detail.vue?vue&type=style&index=0&id=898466c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898466c2",
  null
  
)

export default component.exports